import { createApi, fetcher } from '@blockworks/platform/api';
import {
    BeehiivPublicationSlugs,
    GetPostsRequest,
    GetPostsResponse,
    getPublicationIdBySlug,
    GetPublicationsResponse,
    SubscribeToPublicationInputs,
} from '@blockworks/platform/api/beehiiv';

import { BEEHIIV_ENDPOINTS } from './beehiiv.model';

const beehiivApi = createApi(build => ({
    get: {
        posts: build<GetPostsResponse, GetPostsRequest>({
            cachePrefix: 'beehiiv-posts',
            baseUrl: 'same-origin',
            query: ({
                audience,
                content_tags,
                direction,
                expand,
                publication,
                hidden_from_feed,
                limit = 24,
                order_by,
                platform,
                status = 'confirmed',
                page,
            }) => {
                return {
                    uri: BEEHIIV_ENDPOINTS.GET.POSTS({
                        publicationId: getPublicationIdBySlug(publication as BeehiivPublicationSlugs),
                    }),
                    params: {
                        audience,
                        content_tags,
                        hidden_from_feed,
                        platform,
                        status,
                        limit,
                        direction,
                        order_by,
                        page,
                        expand,
                    },
                    options: {
                        headers: { Authorization: `Bearer ${process.env.BEEHIIV_API_KEY}` },
                    },
                };
            },
        }),
        publications: build<GetPublicationsResponse, undefined>({
            cachePrefix: 'beehiiv-publications',
            baseUrl: 'same-origin',
            query: () => {
                return {
                    uri: BEEHIIV_ENDPOINTS.GET.PUBLICATIONS(),
                    options: {
                        headers: { Authorization: `Bearer ${process.env.BEEHIIV_API_KEY}` },
                    },
                };
            },
        }),
    },
    post: {
        subscribeToPublication: build<any, SubscribeToPublicationInputs>({
            cachePrefix: 'subscribe-beehiiv',
            baseUrl: 'same-origin',
            query: ({
                publication,
                email,
                source,
                campaign,
                medium,
                sourcePath,
                reactivate_existing = false,
                send_welcome_email = true,
                custom_fields = [],
            }) => ({
                uri: BEEHIIV_ENDPOINTS.POST.SUBSCRIBE({
                    publicationId: getPublicationIdBySlug(publication as BeehiivPublicationSlugs),
                }),
                options: {
                    method: fetcher.Method.Post,
                    headers: {
                        Authorization: `Bearer ${process.env.BEEHIIV_API_KEY}`,
                    },
                    body: {
                        email,
                        reactivate_existing,
                        send_welcome_email,
                        utm_source: source,
                        utm_campaign: campaign,
                        utm_medium: medium,
                        referring_site: `blockworks.co${sourcePath}`,
                        custom_fields,
                    },
                },
            }),
        }),
    },
}));

export { beehiivApi };
